<template>
  <div class="py-10 mx-auto" :style="{ minHeight: `calc(100vh - 260px)` }">
    <main>
      <div class="mx-auto max-w-7xl px-2 md:px-8">
        <div class="max-w-[600px] mx-auto">
          <slot/>
        </div>
      </div>
    </main>
  </div>
</template>
